function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#868789",
  x: 0,
  y: 0,
  width: 36,
  height: 36
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.888,8.526 L18.716,8.526 C21.282,8.526 22.79,9.582 22.79,11.996 C22.79,14.41 21.282,15.618 18.716,15.768 L13.888,15.768 L13.888,8.524 L13.888,8.526 Z M13.888,20.296 L20.074,20.296 C22.036,20.296 22.338,22.408 22.488,23.918 C22.6918865,26.3519488 23.0445457,28.7711378 23.544,31.162 L30.032,31.162 C29.0717298,29.1317683 28.5568768,26.9196053 28.522,24.674 C28.07,20.902 28.07,18.186 23.542,17.732 L23.542,17.732 C26.8143542,17.248697 29.2110497,14.3987582 29.126,11.092 C29.126,5.508 24.298,4 19.62,4 L8.002,4 L8.002,31.162 L13.888,31.162 L13.888,20.298 L13.888,20.296 Z",
  fill: "#FFFFFF"
}));

var SvgRBahn = function SvgRBahn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    style: {
      background: "#868789"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRBahn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/r-bahn.5d59e8f8.svg";
export { ForwardRef as ReactComponent };